import React from "react";
import { Link } from "react-router-dom";
import { officeDeatils } from "../../../interface/officedetails.interface";

function ContactInfoBanner({ officeDetails }: { officeDetails: officeDeatils }) {
  const cityPin = [
    officeDetails.cities,
    officeDetails.pincode,
  ]
    .filter(Boolean)
    .join(" - ");
  return (
    <section className="headOfficeWrapper py-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <div className="headOfficeImg">
              <img
                src={
                  officeDetails.images[0] ||
                  "/assets/images/contact-img1.webp"
                }
                alt="office"
              />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="headOfficeHldr">
              <h2 className="titleMain">HEAD OFFICE</h2>
              <div className="headOfficeAddress">
                <h2>{officeDetails.officeName}</h2>
                {officeDetails.addressLine1 && <p>{officeDetails.addressLine1}</p>}
                {officeDetails.addressLine2 && <p>{officeDetails.addressLine2}</p>}
                {cityPin && <p>{cityPin}, {officeDetails.state && officeDetails.state},</p>}
                India
              </div>
              <div className="contactInfo">
                <h2 className="mb-3">Contact Info</h2>
                {officeDetails.emailAddress && (
                  <p className="mb-3">
                    <Link to={`mailto:${officeDetails.emailAddress}`}>
                      <i className="fa fa-envelope me-1"></i>
                      {officeDetails.emailAddress}
                    </Link>
                  </p>
                )}
                {officeDetails.mobileNo && (
                  <p className="mb-3">
                    <i className="fa fa-phone me-1"></i>
                    {officeDetails.mobileNo}
                  </p>
                )}
                {officeDetails.location && (
                  <p className="mt-3">
                    <Link
                      to={officeDetails.location}
                      target="_blank"
                      style={{ color: "#0b44ef", textDecoration: "none" }}
                    >
                      <i className="fa fa-map-marker me-1"></i>
                      Click For Map
                    </Link>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactInfoBanner;